/**
 * Created by rorschach on 2018/5/25.
 */
import pathToRegexp from "path-to-regexp";
import querystring from "querystring";
import utils from "../utils/utils";

class ReactRouterUrl {
  constructor(options) {
    this.options = options;
    this.formatPath = pathToRegexp.compile(this.options.path);
    this.pushMe = this.pushMe.bind(this);
    this.repalceMe = this.repalceMe.bind(this);
  }

  getPath() {
    return this.options.path;
  }

  getComponent() {
    return this.options.component;
  }

  formatUrl(params = {}, query) {
    let _url = this.formatPath(params);
    if (query) {
      _url += `?${querystring.encode(query)}`;
    }
    return _url;
  }

  pushMe(params = {}, query) {
    return utils.pushUrl(this.formatUrl(params, query));
  }

  repalceMe(params = {}, query) {
    return utils.replaceUrl(this.formatUrl(params, query));
  }
}

export default ReactRouterUrl;



// WEBPACK FOOTER //
// ./src/router/ReactRouterUrl.js